import useId from "../behavior/useId";
import PlayIcon from "@heroicons/react/outline/PlayIcon";
import React, { useState } from "react";
import { Entry } from "../behavior/useEntries";
import useEntryState, { EntryStatus } from "../behavior/useEntryState";

interface EntryProps {
  entry: Entry;
  href?: string;
}

const EntryComponent = React.forwardRef<HTMLAnchorElement, EntryProps>(
  function Entry({ entry, href }, ref) {
    const id = useId();
    const { data, setData } = useEntryState(entry.id);

    const { title: label, date: description, video } = entry;

    return (
      <div className="relative flex items-center space-x-4 p-4 rounded-md hover:bg-gray-100">
        <div className="flex items-center h-5">
          <input
            id={id}
            aria-describedby={`${id}-description`}
            name={id}
            type="checkbox"
            className="focus:ring-indigo-500 h-8 w-8 text-indigo-600 border-gray-300 rounded-full"
            checked={data?.status === EntryStatus.Complete}
            onChange={(e) =>
              setData({
                status: e.currentTarget.checked
                  ? EntryStatus.Complete
                  : EntryStatus.Incomplete,
              })
            }
          />
        </div>
        <a
          ref={ref}
          href={href}
          className="ml-3 text-lg flex-grow hover:underline"
        >
          <div className="font-medium text-gray-700">{label}</div>
          <p id={`${id}-description`} className="text-gray-500">
            {description}
          </p>
        </a>
        {video ? (
          <div className="flex items-center">
            <PlayIcon className="w-8 h-8" />
          </div>
        ) : null}
      </div>
    );
  }
);

export default EntryComponent;
